import { Component, signal, computed, input, model } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IconsModule } from '@progress/kendo-angular-icons';
import { KENDO_BUTTONS } from "@progress/kendo-angular-buttons";
import { KENDO_LABELS } from "@progress/kendo-angular-label";
import { KENDO_DATEINPUTS } from '@progress/kendo-angular-dateinputs';
import { KENDO_COMBOBOX } from "@progress/kendo-angular-dropdowns";
import { Store } from '@ngrx/store';
// import { selectLocationsForNOA, selectLocationsItems } from '@pmis3/master-data-core';
import { selectEditingVesselActivities, selectLocationsForNOA, selectSelectedVesselVisit, selectTerminalsForNOA, UpdateVesselActivitiesBeingEdited, VesselStopTypeForStepper } from '@pmis3/vessel-activity-core';
import { VesselActivityHelper } from '@pmis3/vessel-activity-core';
import { ILocationForNOA, LocationTypeForNOA } from '@pmis3/master-data-core';
import { IVesselActivity } from 'libs/vessel-activity/vessel-activity-core/src/lib/vessel-visit/model/vessel-activity';
import { VesselVisitStepperHelper } from '../vesselVisitStepper.helper';
import { DateTimeFormat } from '@pmis3/core';

@Component({
    selector: 'pmis3-vessel-visit-stepper-popup',
    standalone: true,
    imports: [CommonModule, IconsModule, KENDO_BUTTONS, KENDO_LABELS, KENDO_DATEINPUTS, KENDO_COMBOBOX],
    templateUrl: './vessel-visit-stepper-popup.component.html',
    styleUrl: './vessel-visit-stepper-popup.component.scss'
})
export class VesselVisitStepperPopupComponent {
    dateFormat = DateTimeFormat.kendoDateTimeFormat;
    vesselActivities = this.store.selectSignal(selectEditingVesselActivities);
    vesselVisit = this.store.selectSignal(selectSelectedVesselVisit);
    locations = this.store.selectSignal(selectLocationsForNOA);
    terminalsDropdown = this.store.selectSignal(selectTerminalsForNOA);

    selectedTerminal = signal<ILocationForNOA | undefined>(undefined);
    selectedBerth = signal<ILocationForNOA | undefined>(undefined);
    berthDropdown = computed(() => this.locations()?.filter(location => location.parentId == this.selectedTerminal()?.id) ?? [])

    insertPosition = input.required<number>();
    activePopupIndex = model<number | null>();

    previousStop = computed(() => {
        const previousStopIndex = this.insertPosition() - 1 < 0 ? null : this.insertPosition() - 1;
        const vesselActivities = this.vesselActivities()

        if(previousStopIndex == null || !vesselActivities) return null;

        for(let i = previousStopIndex; i >=0; i--) {
            const activity = vesselActivities[i];
            if (!activity.isDeleted) {
                return activity as IVesselActivity;
            }
        }
        return null;
    })
    previousStopEndTime = computed(() => this.previousStop()?.estimatedEndTime ?? (this.vesselVisit()?.pilotStationETD ?? null));
    nextMovement = computed(() => {
        const position = this.insertPosition();
        const vesselActivities = this.vesselActivities();

        if(position == null || !vesselActivities) return null;

        for(let i = position; i < vesselActivities.length; i++) {
            const activity = vesselActivities[i];
            if (!activity.isDeleted) {
                return activity as IVesselActivity;
            }
        }
        return null;
    })

    addEventDisabled = computed(() => this.startTimeIsInvalid() || this.endTimeIsInvalid() || !this.selectedTerminal())

    showLocationAndETAPicker = signal(false);
    selectedLocation = signal<ILocationForNOA | undefined>(undefined);
    startTime = signal<Date | null>(null);
    endTime = signal<Date | null>(null);

    startTimeIsInvalid = computed(() => VesselVisitStepperHelper.timeIsInvalid(this.startTime(), this.previousStopEndTime(), this.endTime()));
    endTimeIsInvalid = computed(() => VesselVisitStepperHelper.timeIsInvalid(this.endTime(), this.startTime(), this.nextMovement()?.estimatedEndTime));

    constructor(private store: Store<any>) { }

    onTerminalChange() {
        this.selectedBerth.set(undefined)
    }

    onAddMovement() {
        const originalVesselActivities = this.vesselActivities() ?? [];
        const insertPosition = this.insertPosition();
        const vesselVisitId = this.vesselVisit()?.id;
        const startTime = this.startTime();
        const endTime = this.endTime() ?? undefined;
        const selectedLocation = this.selectedBerth() ?? this.selectedTerminal();

        if (vesselVisitId == undefined || !startTime) {
            return;
        }

        const updatedVesselActivities = VesselActivityHelper.updateVesselActivities(
            originalVesselActivities,
            vesselVisitId,
            insertPosition,
            startTime,
            endTime,
            selectedLocation
        );

        const newStopIndex = insertPosition + 1;
        const editingActivitiesIndices = VesselActivityHelper.getIndicesForEditingOnSelectingStop(
            newStopIndex,
            updatedVesselActivities
        );

        this.store.dispatch(UpdateVesselActivitiesBeingEdited({
            vesselActivities: updatedVesselActivities,
            editingIndices: editingActivitiesIndices
        }));

        this.activePopupIndex.set(null);
    }

}

